import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/knowledgebase/bg_1.jpg'


const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "knowledgebase-search" }
const _hoisted_3 = { colClass: "col-xl-5 col-md-6 proorder-xl-1 proorder-md-1" }
const _hoisted_4 = { class: "img-overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "knowledgebase-bg" }, [
      _createElementVNode("img", {
        class: "bg-img-cover bg-center",
        src: _imports_0,
        alt: "loginpage"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, "Bienvenue, " + _toDisplayString(_ctx.userName) + " " + _toDisplayString(_ctx.userLastName), 1),
          _createVNode(_component_router_link, {
            class: "btn",
            to: "/"
          })
        ])
      ])
    ])
  ]))
}